import { IList } from '../../../../../types/ComponentTypes/Components'
import { Label } from '@sainsburys-tech/luna-form'
import parse from 'html-react-parser'

function ListComponent({ label, listValues }: IList) {
  return (
    <div id="s-reporting-list">
      <Label htmlFor=""> {label} </Label>
      <ul className="s-reporting-list">
        {listValues.map((list, index) => (
          <li id="s-reporting list" key={index}>
            {parse(list)}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default ListComponent
